function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 0V26H11.5V22H13.5V26H24.5V0H0.5ZM2.5 2H22.5V24H15.5V20H9.5V24H2.5V2ZM4.5 4V6H8.5V4H4.5ZM10.5 4V6H14.5V4H10.5ZM16.5 4V6H20.5V4H16.5ZM4.5 8V10H8.5V8H4.5ZM10.5 8V10H14.5V8H10.5ZM16.5 8V10H20.5V8H16.5ZM4.5 12V14H8.5V12H4.5ZM10.5 12V14H14.5V12H10.5ZM16.5 12V14H20.5V12H16.5ZM4.5 16V18H8.5V16H4.5ZM10.5 16V18H14.5V16H10.5ZM16.5 16V18H20.5V16H16.5ZM4.5 20V22H8.5V20H4.5ZM16.5 20V22H20.5V20H16.5Z",
  fill: "#C8C8C9"
});

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.67e94199.svg";
export { ForwardRef as ReactComponent };